import React from "react";
import {GlobalState} from "../../global/GlobalState";
import {translateFunction} from "../../localization/TranslationService";

const translate = translateFunction();

export function HomePage() {
	let message = "Welcome to Kizi portal.";
	
	if (!GlobalState.userSession)
		message = "Login to continue";
	
	// todo if user has no groups other than the default group, also show message that they have to have their groups assigned by an administrator
	
	return <div>{translate(message)}</div>;
	
}
